module.exports = __webpack_public_path__ + "img/twoOrange.b11924f2.jpg";